/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Seo_DescInputs */

const en_b2b_seo_desc = /** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch a compliant, white-labeled storefront on your own domain. Integrated AI Concierge, custom checkouts, and VIP client portals for Dealerships, Agencies, and Enterprises.`)
};

const es_b2b_seo_desc = /** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza una tienda de marca blanca compatible en tu propio dominio. Conserje IA integrado y portales de clientes VIP para concesionarios, agencias y empresas.`)
};

const fr_b2b_seo_desc = /** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez une vitrine en marque blanche conforme sur votre propre domaine. Concierge IA intégré, paiements personnalisés et portails clients VIP pour les concessionnaires, agences et entreprises.`)
};

const de_b2b_seo_desc = /** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte eine konforme, whitelabeled Storefront auf deiner eigenen Domain. Integrierter KI-Concierge und VIP-Kundenportale.`)
};

const id_b2b_seo_desc = /** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan etalase white-label yang patuh pada domain kustom Anda. Terintegrasi Pramutamu AI, checkout kustom, dan portal klien VIP untuk Dealer, Agensi, dan Perusahaan.`)
};

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const ja_b2b_seo_desc = en_b2b_seo_desc;

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const zh_b2b_seo_desc = en_b2b_seo_desc;

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const ar_b2b_seo_desc = en_b2b_seo_desc;

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const it_b2b_seo_desc = en_b2b_seo_desc;

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const ru_b2b_seo_desc = en_b2b_seo_desc;

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const pt_b2b_seo_desc = en_b2b_seo_desc;

/** @type {(inputs: B2b_Seo_DescInputs) => LocalizedString} */
const ko_b2b_seo_desc = en_b2b_seo_desc;

/**
* | output |
* | --- |
* | "Launch a compliant, white-labeled storefront on your own domain. Integrated AI Concierge, custom checkouts, and VIP client portals for Dealerships, Agencies,..." |
*
* @param {B2b_Seo_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_seo_desc = /** @type {((inputs?: B2b_Seo_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Seo_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_seo_desc(inputs)
	if (locale === "es") return es_b2b_seo_desc(inputs)
	if (locale === "fr") return fr_b2b_seo_desc(inputs)
	if (locale === "de") return de_b2b_seo_desc(inputs)
	if (locale === "ja") return ja_b2b_seo_desc(inputs)
	if (locale === "zh") return zh_b2b_seo_desc(inputs)
	if (locale === "ar") return ar_b2b_seo_desc(inputs)
	if (locale === "id") return id_b2b_seo_desc(inputs)
	if (locale === "it") return it_b2b_seo_desc(inputs)
	if (locale === "ru") return ru_b2b_seo_desc(inputs)
	if (locale === "pt") return pt_b2b_seo_desc(inputs)
	return ko_b2b_seo_desc(inputs)
});